<template>
  <div class="h-auto mr-3 mb-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-2">
        <p class="text-sm font-semibold w-full">List of Assets</p>
        <!-- Bulk Action -->
        <div class="flex" v-if="assetIds.length">
          <button class="bg-primary text-white" @click="showConfirmationDiag">
            Delete
          </button>
        </div>
        <!-- Bulk Action -->
      </div>
      <div class="flex justify-between items-center p-2">
        <el-pagination
          background
          @size-change="handleSizeChange"
          :page-sizes="pageSizes"
          :page-index="pageIndex"
          :page-size="pageSize"
          layout="sizes"
          :total="currentTableData.length"
        >
        </el-pagination>
        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="bg-gray-200 w-52 py-3 rounded-md"
        />
        <!-- search -->
        <div class="flex flex-wrap justify-end w-full gap-3">
          <div class="flex flex-wrap whitespace-nowrap gap-2">
            <button
              @click="showBulkUploadForm"
              class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
              style="
                justify-items: center;
                align-items: center;
                justify-content: center;
              "
            >
              <img class="h-5" src="@/assets/icons/export-excel.png" />
              Import
            </button>
            <button
              @click="exportTemplate"
              class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
              style="
                justify-items: center;
                align-items: center;
                justify-content: center;
              "
            >
              <img class="h-5" src="@/assets/icons/export-excel.png" />
              Export
            </button>
          </div>
          <button
            @click="showCreateAsset = true"
            class="border-1.5 rounded-full px-2 py-1 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white text-center items-center border-primary flex gap-1 capitalize"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            Create
          </button>
        </div>
      </div>
      <div class="pb-2 w-full px-2">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="create_success"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="del_document"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_document }}
          </div>
        </transition>
        <div class="w-full overflow-x-scroll">
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
            row-key-field-name="Id"
            :checkbox-option="checkboxOption"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
            row-key-field-name="Id"
            :checkbox-option="checkboxOption"
          >
          </ve-table>
          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No assets found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
      </div>
    </div>
    <!-- create -->
    <CreateAsset
      @close="showCreateAsset = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :showCreateAsset="showCreateAsset"
      :reload="reload"
    >
    </CreateAsset>

    <!-- edit -->
    <EditAsset
      @close="handleClose"
      :info="assetToEdit"
      :showEditAsset="showEditAsset"
      :reload="reload"
    >
    </EditAsset>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
    <!-- <BulkUploadAssets
      :show-asset-bulk-upload="showAssetBulkUpload"
      v-if="showAssetBulkUpload"
      @close="showAssetBulkUpload = false"
      :reload="reload"
    ></BulkUploadAssets> -->

    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      :title="title"
      dataType="Assets"
      :url="url"
      :dateColumns="[]"
      :columns="resultColumns"
    ></BulkUpload>
  </div>
</template>

<script>
import axios from "axios";
import CreateAsset from "@/components/CompanySetups/assetsSetups/create.vue";
import EditAsset from "@/components/CompanySetups/assetsSetups/editAsset.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import { mapGetters } from "vuex";
// import { utils, writeFileXLSX } from "xlsx";
// import BulkUploadAssets from "@/components/employees/modals/bulkUploadAssets.vue";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import decryptData from "@/utils/decrypt";

export default {
  name: "assetsList",
  components: {
    Loader,
    CreateAsset,
    ActionWarning,
    EditAsset,
    BulkUpload: () => import("@/utils/bulkUploadsUtils.vue"),

    // BulkUploadAssets,
  },

  data() {
    return {
      assetIds: [],
      showAssetBulkUpload: false,
      showCreateAsset: false,
      showEditAsset: false,
      loading: false,
      get_error: null,
      create_success: null,
      del_document: null,
      del_error: null,
      url: "",
      resultColumns: [],
      showBulkUpload: false,
      info: null,
      message: null,
      title: null,
      del_success: null,
      searchInput: "",
      showActions: false,
      assetToDelete: null,
      showWarning: false,
      assetToEdit: {},
      assetTypes: [],
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: 50,
          align: "center",
        },
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "AssetNo",
          key: "AssetNo",
          title: "Unique Number",
          headerAlign: "left",
          align: "left",
          sampleValue: "#123456",
        },
        {
          field: "SerialNumber",
          key: "SerialNumber",
          title: "Serial Number",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) =>
            row.SerialNumber
              ? row.SerialNumber
              : Array.from({ length: 15 }).fill("."),
          sampleValue: "S123456", // Add a sample value
        },

        {
          //change
          field: "AssetBrand",
          key: "AssetBrandName",
          title: "Brand",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) =>
            row.AssetBrand
              ? row.AssetBrand
              : Array.from({ length: 15 }).fill("."),
          sampleValue: "Apple", // Add a sample value
        },
        {
          field: "AssetModel",
          key: "AssetModel",
          title: "Model",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) =>
            row.AssetModel
              ? row.AssetModel
              : Array.from({ length: 15 }).fill("."),
          sampleValue: "Mac Book Pro", // Add a sample value
        },

        {
          field: "AssetType",
          key: "AssetType",
          title: "Type",
          headerAlign: "left",
          align: "left",
          sampleValue: "Laptop", // Add a sample value
        },

        {
          field: "AssetStatus",
          key: "AssetStatus",
          title: "Status",
          headerAlign: "left",
          align: "center",
          sampleValue: "Active", // Add a sample value
        },
        {
          field: "AssetCondition",
          key: "AssetCondition",
          title: "Condition",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) =>
            row.AssetCondition
              ? row.AssetCondition
              : Array.from({ length: 15 }).fill("."),
          sampleValue: "New", // Add a sample value
        },
        {
          field: "AssignedTo",
          key: "AssignedTo",
          title: "Assigned To",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) =>
            row.AssignedTo
              ? decryptData(row.AssignedTo, this.$decryptionKey)
              : Array.from({ length: 15 }).fill("."),
          sampleValue: "DP-001", // Add a sample value
        },

        {
          field: "Description",
          key: "Description",
          title: "Description",
          headerAlign: "left",
          align: "left",
          sampleValue: "Brand new silver Mac Book.", // Add a sample value
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-3 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>

                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
      checkboxOption: {
        // row select change event
        selectedRowChange: ({ isSelected, selectedRowKeys }) => {
          if (isSelected) {
            this.assetIds = selectedRowKeys;
          } else {
            this.assetIds = [];
          }
        },
        // selected all change event
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          if (isSelected) {
            this.assetIds = selectedRowKeys;
          } else {
            this.assetIds = [];
          }
        },
      },
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getAssets();
    this.getAssetTypes();
    this.setPageSizes();
  },
  methods: {
    showBulkUploadForm() {
      this.resultColumns = this.columns.filter(
        (col) => col.title !== "Action" && col.title !== "" && col.title !== "#"
      );
      this.url = `${this.getOrganization}/asset/bulk/${this.$ApiVersion}/upload`;
      this.showBulkUpload = true;
    },

    showBulkUploadCallback() {
      this.showBulkUpload = false;
      this.getAssets();
    },
    showConfirmationDiag() {
      this.$confirm(
        "You are about to unassign the selected assets. Do you want to proceed?",
        "Unassign Assets"
      )
        .then((response) =>
          response === "confirm" ? this.deleteBulk(this.assetIds) : null
        )
        .catch((error) => console.log(error));
    },
    reload() {
      this.getAssets();
      this.showEditAsset = false;
      this.showCreateAsset = false;
      setTimeout(() => {
        this.showAssetBulkUpload = false;
      }, 3000);
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleEditButtonClick(asset) {
      this.assetToEdit = asset;

      this.showEditAsset = true;
    },
    findAssetBrandByName(selectedAsset) {
      this.info.AssetBrandId = this.assetBrand.find(
        (brand) => brand.Name == selectedAsset
      ).Id;
    },
    handleDeleteButtonClick(asset) {
      this.title = `Delete ${asset.Name}`;
      this.message = `You are about to delete ${asset.Name} from the assets list!`;
      this.assetToDelete = asset;
      //console.log(this.assetToDelete)
      this.showWarning = true;
    },
    setIsConfirmed() {
      this.showWarning = false;
      if (this.assetToDelete) {
        this.deleteAsset(this.assetToDelete);
        return;
      }
    },
    handleClose() {
      this.showCreateAsset = false;
      this.showEditAsset = false;
    },
    handleCloseOnSuccess() {
      this.showCreateAsset = false;
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getAssets();
    },

    handleDeleteOnSuccess() {
      setTimeout(() => {
        this.showLocDelSuccess = null;
      }, 3000);
      this.getAssets();
    },

    Adddocument(row) {
      this.selectedRow = row;
      this.showAdddocument = true;
    },

    handleCloseOnAddDept() {
      this.showAdddocument = false;
      this.showAdddocumentSuccess = true;
      setTimeout(() => {
        this.showAdddocumentSuccess = false;
      }, 3000);
    },

    // /{organization}/asset/v1/request
    getAssets() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
              setTimeout(() => {
                this.del_error = null;
              }, 2000);
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 2000);
          }
        );
    },

    // /{organization}/asset/v1/request
    getAssetTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/type/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.assetTypes = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
              setTimeout(() => {
                this.del_error = null;
              }, 2000);
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 2000);
          }
        );
    },
    // /{organization}/asset/type/v1/request
    getAssetBrand() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/brand/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.assetBrand = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // /{organization}/asset/v1/delete
    deleteAsset(row) {
      //console.log(row)
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          AssetId: row.Id,
        },
      };
      axios.delete(`${this.getOrganization}/asset/v1/delete`, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.showLocDelSuccess = response.data.StatusMessage;
            this.handleDeleteOnSuccess();
            // this.getAssets()
          } else {
            setTimeout(() => {
              this.del_error = null;
            }, 2000);
            this.del_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.del_error = error.message;
          setTimeout(() => {
            this.del_error = null;
          }, 2000);
        }
      );
    },

    deleteBulk(ids) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
        data: {
          Id: "",
        },
      };
      ids.forEach((id) => {
        options.data.AssetId = id;
        axios.delete(`${this.getOrganization}/asset/v1/delete`, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.del_success = response.data.StatusMessage;
              setTimeout(() => {
                this.del_success = null;

                this.handleDeleteOnSuccess();
              }, 2000);
            } else {
              this.del_error = response.data.StatusMessage;
              setTimeout(() => {
                this.del_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 3000);
          }
        );
      });
    },

    exportTemplate() {
      let filteredTabs = this.columns.filter(
        (column) =>
          column.title !== "Action" &&
          column.title !== "#" &&
          column.title !== ""
      );
      importTemplateGenerator(filteredTabs, "Assets");
      // const columnToUse = this.columns.slice(1, -1); // Remove first and last columns
      // console.log(columnToUse);
      // const templateData = [
      //   columnToUse.map((col) => col.title.split(" ").join("")),
      // ]; // Create an array for headers

      // const sampleDataRow = columnToUse.map((col) => col.sampleValue || ""); // Create an array for sample data

      // templateData.push(sampleDataRow); // Push the sample data array as the second row

      // const ws = utils.aoa_to_sheet(templateData); // Convert arrays to worksheet
      // const wb = utils.book_new();

      // // Add info worksheet
      // const infoData = [
      //   ["This is a template for organization assets data."],
      //   [
      //     "The headers(row 1) should NOT be altered, as it will affect the bulk upload.",
      //   ],
      //   [
      //     "Refer to the sample data in row 2 when filling in your organization's data.",
      //   ],
      // ];
      // const infoWs = utils.aoa_to_sheet(infoData);
      // utils.book_append_sheet(wb, infoWs, "Info");

      // // Add template worksheet
      // utils.book_append_sheet(wb, ws, "Template");

      // writeFileXLSX(wb, "assets-template.xlsx");
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}
</style>
